exports.IDS = {
  // IMG_URL: "http://192.168.16.56:1122",
  // IMG_URL: "http://192.168.16.56:1122",
  // IMG_URL: "https://super30node.profcymadev.com:1122",
  IMG_URL: "https://super30.audio-meet.com",
  PAGE: 1,
  PERPAGE: 10,
  TOTALPAGES: 1,
  TOTAL: 1,
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  SLICESTATUS: {
    Idle: "idle",
    Loading: "loading",
    Succeeded: "succeeded",
    Failed: "failed",
  },
};
